// card-grid-core.js — logica PURA del componente condiviso CardGrid (F2.3g,
// SECONDO mattone del design system in client/src/ui/).
// File PURO (niente JSX, niente DOM): è QUESTO che il contract test
// server/src/lib/card-grid.test.js esercita sotto node --test — il JSX
// (CardGrid.jsx) resta un guscio di resa che DELEGA qui ogni decisione.
//
// RIUSO, NON FORK (mandato ondata 22): la selezione dello stato e la chiave
// hanno la STESSA semantica del DataTable — si delega a data-table-core, che
// NON si tocca (i suoi consumatori e i suoi test restano intatti).

import { selectTableState, rowKeyOf } from './data-table-core.js';

// Selezione dello stato da mostrare. Precedenza DICHIARATA (identica al
// DataTable, testata):
//  - card presenti ⇒ 'data' SEMPRE (reload in corso o fallito NON svuota la
//    griglia: il chiamante comunica l'errore col suo banner);
//  - senza card: error ('error', messaggio + Riprova) › loading ('loading',
//    spinner) › 'empty' (messaggio dedicato).
export function selectCardState(s) {
  return selectTableState({
    rows: (s && s.items) || [],
    loading: s && s.loading,
    error: s && s.error,
  });
}

// Chiave di card: campo (stringa), funzione, fallback indice — mai undefined
// (React perderebbe l'identità delle card in silenzio). Stessa funzione del
// DataTable (il prefisso di fallback 'row-' resta: è un dettaglio interno).
export function cardKeyOf(item, itemKey, index) {
  return rowKeyOf(item, itemKey, index);
}

// Guardia click-card: mai aprire la card cliccando un controllo interattivo
// al suo interno (bottoni, input, link, select, o un'area marcata
// .cg-no-card) — stessa semantica della guardia del DataTable (parità
// makeDataTable v1 proc-v0.js:10950).
export function isInteractiveTarget(t) {
  return !!(t && typeof t.closest === 'function' && t.closest('button, input, a, select, .cg-no-card'));
}

// Classe della griglia responsive: 1 colonna di base; 2 colonne dal
// breakpoint dichiarato ('md' = 768px, 'lg' = 1024px — gli stessi breakpoint
// Tailwind delle due griglie del monolite: Templates md, Monitoraggio lg).
// Valore ignoto/assente ⇒ colonna singola (mai una classe inventata).
export function gridClass(twoColAt) {
  if (twoColAt === 'md') return 'cg-grid cg-grid-md2';
  if (twoColAt === 'lg') return 'cg-grid cg-grid-lg2';
  return 'cg-grid';
}
